jQuery( function($) {
    // $(window).on( 'load resize', function() {
    //     if ( $(this).width() >= 960 ) {
            $( 'ul#primary-menu li.menu-item > a' ).click( function ( e ) {
                // e.preventDefault();
                var $this = $( this ).parent().find( '.sub-menu' );
                $( '.sub-menu' ).not( $this ).hide().removeClass( 'active' );
                $this.toggle().toggleClass( 'active' );
                $( this ).toggleClass( 'active' );
                $( 'a.active' ).not( this ).removeClass( 'active' );
                if ( $this.hasClass( 'active' ) ) {
                    $( '.sub-menu-container' ).show();
                } else {
                    $( '.sub-menu-container' ).hide();
                }
            } );
        // } else {
        //     $( '.sub-menu' ).removeClass( 'active' );
        //     return false;
        // }
    // });


    // $(document).ready( function() {
        // $( 'ul#primary-menu' ).slicknav( {
        //     label: 'MENU',
        //     duplicate: true,
        //     brand: '&nbsp;',
        //     parentTag: 'span',
        //     nestedParentLinks: true,
        //     prependTo: '#page',
        //     removeClasses: true,
        //     closedSymbol: '<i class="fa fa-chevron-right"></i>',
        //     openedSymbol: '<i class="fa fa-chevron-down"></i>'
        // });
    // });
});
